import { Component, Input, OnInit } from '@angular/core'
import { Subject } from 'rxjs'
import { get } from 'lodash'

import { QuestionChild } from '../question.component'
import { Question } from '../../../models/question'
import { Response } from '../../../models/response'
import { AnswerStatus, Answer } from '../../../models/answer'

@Component({
  selector: 'capto-question-list',
  templateUrl: './question-list-exclusive.component.html',
  styleUrls: ['./question-list-exclusive.component.scss']
})
export class QuestionListExclusiveComponent implements QuestionChild, OnInit {
  @Input()
  formId: string
  @Input()
  question: Question
  @Input()
  response: Response
  answer: Answer
  answerSelection: Subject<object> = new Subject()

  listInline(): boolean {
    return get(this.question, 'options.list.inline', false)
  }

  ngOnInit(): void {
    this.answer = this.question.answer
  }

  save(id: any): void {
    this.answer = {
      values: { [id]: { id, value: id } },
      status: AnswerStatus.Answered
    }
    this.answerSelection.next(this.answer)
  }
}
